module.exports = __webpack_public_path__ + "static/nielsen-f10764924fb7c051f4945304aa8fb533.svg";